













































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Goodstype from '../../../store/entities/goodstype'
@Component
export default class EditGoodstype extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    user:Goodstype=new Goodstype();
     
      save(){
          
        (this.$refs.userForm as any).validate(async (valid:boolean)=>{
          
            if(valid){
                await this.$store.dispatch({
                    type:'goodstype/update',
                    data:this.user
                });
                (this.$refs.userForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    get goodstypelst(){

          return     this.$store.state.goodstype.goodstypelst;   

    }
    cancel(){
        (this.$refs.userForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        
        if(!value){
            this.$emit('input',value);
        }else{
            
              this.user=Util.extend(true,{},this.$store.state.goodstype.editGoodstype);
            
        //下面小区
          /* let cid_sid= this.$store.state.Goodstype.editGoodstype.streetid;
            
            var sid=  this.area_id(cid_sid,"sarea");
            var qid= this.area_id(sid,"qarea");
            this.qarea_id=qid;
             */
             //下面小区
        

        }
    }
    userRule={
       parentId:[{type:'number', required: true,message:'请选择街道',trigger: 'change'}],
       goodsTypename:[{required:true,message:'请输入分类名称'}],
   
      
    }
 
}



  
 


